import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

export const useDeleteMoneyMapRule = requestBuilder.mutation<
    GeneralResponse,
    null,
    { id: string }
>({
    endpoint: ({ id }) => `/api/admin/money-map/rule/${id}`,
    method: 'DELETE',
});
